import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザのアカウント情報を更新する
 *
 * @param {Number} uid ユーザID
 * @param {Object} account アカウント情報
 * @returns {Response} レスポンスデータ
 */
export function putUserAccount (uid, account) {
  return request.put(`/users/${uid}/account`, account, {
    validateStatus: (status) => [
      http.OK,
      http.Conflict
    ].includes(status)
  })
}
